<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <ul class="heading-ul flex justify-start items-center">
        <li class="flex items-center">
          <router-link
            :to="`/customers/view_customer/${$route.params.clientId}`"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
          </router-link>
        </li>
        <li>
          <h3>
            <div class="table-heading">
              {{ $t("customers.label.PaymentDetails") }}
            </div>
          </h3>
        </li>
      </ul>
    </div>
    <div class="vx-col w-full">
      <vx-card title no-shadow card-border>
        <div
          class="overflow-x-auto flex flex-col justify-center items-center"
          id="pdfContractInfo"
          ref="pdfContractInfo"
        >
          <!-- <div class="flex justify-between items-end" style="width: 40%">
            <span class="text-3xl">Lyca Mobile</span>
            <img
              src="@/assets/images/logo/lyca.png"
              class="object-contain h-10 mt-4"
              alt=""
            />
          </div> -->
          <h2>{{$t("customers.label.PaymentReceipt")}}</h2>
          <div class="receipt-line"></div>
          <table class="">
            <tr>
              <td>
                <b>{{ $t("customers.label.transaction_id") }}</b>
              </td>
              <td>
                {{ paymentDetails.transactionId }}
              </td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.user_name") }}</b>
              </td>
              <td>{{ paymentDetails.userName }}</td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.transaction_date") }}</b>
              </td>
              <td>
                {{ paymentDetails.transDate | formatedate }}
              </td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.transaction_type") }}</b>
              </td>
              <td>
                {{ paymentDetails.transactionType }}
              </td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.category") }}</b>
              </td>
              <td>
                {{ paymentDetails.transactionCategory }}
              </td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.Status") }}</b>
              </td>
              <td>{{ paymentDetails.status }}</td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.PaymentAmount") }}</b>
              </td>
              <td>{{ paymentDetails.amount }}</td>
            </tr>
            <tr>
              <td>
                <b>{{ $t("customers.label.credit_amount") }}</b>
              </td>
              <td>{{ paymentDetails.creditAmount }}</td>
            </tr>
            <tr>
              <td class="border-none">
                <b>{{ $t("customers.label.Transaction") }}</b>
              </td>
              <td>{{ paymentDetails.transaction }}</td>
            </tr>
          </table>
        </div>
        <div class="flex justify-center items-center mt-6">
          <vs-button
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-download"
            class="truncate donwloadbtn"
            size="medium"
            @click="downloadPfd('pdfContractInfo')"
            >{{ $t("customers.label.download") }}</vs-button
          >
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-x"
            class="truncate donwloadbtn"
            size="medium"
            @click="openCancelPayment(paymentDetails)"
            >{{ $t("customers.label.cancel") }}</vs-button
          >
        </div>
      </vx-card>
    </div>
    <!-- <div class="centerx"> -->
    <vs-popup
      classContent="popup-example"
      :title="$t('customers.label.cancelPayment')"
      :active.sync="modalVisible"
      class="popup-close mid-popup"
    >
      <form>
        <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
          <div class="vx-col mb-2 w-full">
            <small class="date-label font-semibold">{{
              $t("customers.label.cancelRemark")
            }}</small>
            <vs-textarea v-model="cancelremark" />
          </div>
        </div>

        <div class="vx-row">
          <span class="ml-4 mr-1">
            <vs-button type="border" @click="modalVisible = false">{{
              $t("customers.label.close")
            }}</vs-button>
          </span>
          <span class="ml-1 mr-2">
            <vs-button @click="paymentReversal">{{
              $t("customers.label.confirm")
            }}</vs-button>
          </span>
        </div>
      </form>
    </vs-popup>
    <!-- </div> -->
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      clientId: "",
      modalVisible: false,
      cancelremark: "",
      transactionId: "",
    };
  },
  computed: {
    ...mapState({
      transactions: (state) => state.customerAccount.transactionDetails,
    }),
    paymentDetails() {
      const transactionId = this.$route.params.id;
      let obj = this.transactions.find(
        (transaction) => transaction.transactionId === Number(transactionId)
      );
      return obj ? obj : {};
    },
  },
  methods: {
    downloadPfd(pdfType) {
      this.generatePDF(pdfType);
    },
    generatePDF(pdfType) {
      const element = this.$refs[pdfType];
      element.style.display = "block";
      element.style.marginTop = "0px";
      pdfType === "pdfContractInfo"
        ? html2pdf().from(element).save("payment_Details.pdf")
        : html2pdf().from(element).save("payment_Details.pdf");
    },
    async openCancelPayment(paymentDetails) {
      this.modalVisible = true;
      this.transactionId = paymentDetails.transactionId;
    },
    async paymentReversal() {
      try {
        const cancelRemarkObj = {
          cancelRemark: this.cancelremark,
          clientPoId: 0,
        };
        await this.$store.dispatch("customerPayment/cancelPaymentAction", {
          id: this.transactionId,
          data: cancelRemarkObj,
        });

        this.cancelremark = "";
        this.modalVisible = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Payment Reversal Successful!",
          type: "success",
        });
        setTimeout(() => {
          this.$router.push(
            `/customers/view_customer/${this.$route.params.clientId}`
          );
        }, 300);
      } catch (e) {
        console.log(
          "Something went wrong while retrieving payment cancel: ",
          e
        );
      }
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
};
</script>
<style>
.donwloadbtn {
  margin-left: 15px;
}
.receipt-line {
  width: 40%;
  padding: 5px;
  border-bottom: 1px solid #777;
}
</style>
